import React, { useState } from 'react';

 export default function Toggle ({ label, initialValue, handleChange, enable = true }) {
  const [isChecked, setIsChecked] = useState(initialValue);

  const handleToggle = () => {
    if (enable) {
      setIsChecked(prevState => !prevState);
      handleChange(!isChecked); // Llama la función handleChange
    }
  };

  return (
    <div className="flex items-center space-x-3">
      <label htmlFor="toggle" className="text-gray-700">{label}</label>
      <button
        id="toggle"
        onClick={handleToggle}
        disabled={!enable}
        className={`relative inline-flex items-center cursor-pointer w-12 h-6 rounded-full transition-colors 
          ${isChecked ? 'bg-lightblue' : 'bg-gray-400'} 
          ${!enable ? 'opacity-50 cursor-not-allowed' : ''}`}
      >
        <span
          className={`inline-block w-5 h-5 transform bg-white rounded-full transition-transform 
            ${isChecked ? 'translate-x-6' : 'translate-x-0'}`}
        />
      </button>
    </div>
  );
};